import React, { useCallback, useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

/** Quadro para desenhar a assinatura com o dedo ou o mouse. Devolve um PNG (data URL) ou null se estiver vazio. */
export default function SignaturePad({ onChange, height = 170 }) {
  const ref = useRef(null);
  const desenhando = useRef(false);
  const ultimo = useRef(null);
  const [vazio, setVazio] = useState(true);

  const preparar = useCallback(() => {
    const c = ref.current; if (!c) return;
    const r = c.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
    c.width = Math.round(r.width * dpr); c.height = Math.round(height * dpr);
    const ctx = c.getContext("2d");
    ctx.scale(dpr, dpr); ctx.lineWidth = 2.6; ctx.lineCap = "round"; ctx.lineJoin = "round"; ctx.strokeStyle = "#0F172A";
  }, [height]);

  useEffect(() => { preparar(); window.addEventListener("resize", preparar); return () => window.removeEventListener("resize", preparar); }, [preparar]);

  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return { x: e.clientX - r.left, y: e.clientY - r.top }; };
  const down = (e) => { e.preventDefault(); ref.current.setPointerCapture?.(e.pointerId); desenhando.current = true; ultimo.current = pos(e); const ctx = ref.current.getContext("2d"); ctx.beginPath(); ctx.arc(ultimo.current.x, ultimo.current.y, 0.6, 0, 6.3); ctx.stroke(); };
  const move = (e) => {
    if (!desenhando.current) return; e.preventDefault();
    const p = pos(e), ctx = ref.current.getContext("2d");
    ctx.beginPath(); ctx.moveTo(ultimo.current.x, ultimo.current.y); ctx.lineTo(p.x, p.y); ctx.stroke(); ultimo.current = p;
    if (vazio) setVazio(false);
  };
  const up = () => {
    if (!desenhando.current) return; desenhando.current = false;
    onChange?.(ref.current.toDataURL("image/png"));
  };
  const limpar = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setVazio(true); onChange?.(null); };

  return (
    <div>
      <div className="relative rounded-xl border-2 border-dashed border-slate-300 bg-white" style={{ height }}>
        <canvas ref={ref} data-testid="signature-canvas" className="w-full rounded-xl" style={{ height, touchAction: "none", cursor: "crosshair" }}
          onPointerDown={down} onPointerMove={move} onPointerUp={up} onPointerLeave={up} />
        {vazio && <div className="absolute inset-0 grid place-items-center pointer-events-none text-slate-300 text-sm select-none">Assine aqui com o dedo ou o mouse</div>}
        <div className="absolute left-4 right-4 bottom-8 border-b border-slate-200 pointer-events-none" />
      </div>
      <button type="button" onClick={limpar} className="mt-2 inline-flex items-center gap-1.5 text-xs text-slate-500 hover:text-slate-800" data-testid="signature-clear">
        <Eraser className="h-3.5 w-3.5" /> Limpar e assinar de novo
      </button>
    </div>
  );
}
